import EmailOrder from "../../components/email-orders/EmailOrder";
import { orderTypeOptions } from "../../constants/constants";

const EmailBodyOrder = () => {
  return <EmailOrder orderType={orderTypeOptions.EmailBody} isReprocessBtnEnabled={false}></EmailOrder>;
};

export default EmailBodyOrder;
